import { TabbedPage } from '@/components/TabbedPage';
import FacebookPageOverview from './PageOverview';
import PagePublish from './PagePublish';
import { FileText, PenSquare } from 'lucide-react';

// Organic Page posting — deliberately separate from campaigns/ads. These are
// posts on the Page timeline, not paid placements.
export default function FacebookPageManager() {
  return (
    <TabbedPage
      title="Facebook Page"
      breadcrumb="Facebook Ads"
      description="Organic posts on your Page timeline — published directly, not as ads."
      tabs={[
        { id: 'posts', label: 'Posts', icon: <FileText size={14} />, render: () => <FacebookPageOverview embedded /> },
        { id: 'publish', label: 'Publish', icon: <PenSquare size={14} />, render: () => <PagePublish embedded /> },
      ]}
    />
  );
}
